import { BlockTitle } from "@blocks/Blocks";

import AstarSection from "./AstarSection";
import BusinessTimesSection from "./BusinessTimesSection";
import EnterpriseSingaporeSection from "./EnterpriseSingaporeSection";
import MastercardSection from "./MastercardSection";
import OCBCBankSection from "./OCBCBankSection";
import OliverWymanSection from "./OliverWymanSection";
import PaiaSection from "./PaiaSection";
import RajahAndTannSection from "./RajahAndTannSection";
import RSMSection from "./RSMSection";

/**
 * Component to render Partners Page
 */
const EEPartnersPage = (): React.ReactElement => {
  return (
    <div data-testid="partners-page-component" className="font-public-sans">
      <BlockTitle
        text="Partners"
        rootClassName="text-xl lg:text-8xl font-medium mb-6"
      />

      <div className="mb-5 bg-gray-150 p-4 font-public-sans leading-[1.4]">
        <BusinessTimesSection />

        <OCBCBankSection />

        <RSMSection />

        <MastercardSection />

        <RajahAndTannSection />

        <EnterpriseSingaporeSection />

        <AstarSection />

        <OliverWymanSection />

        <PaiaSection />
      </div>
    </div>
  );
};

export default EEPartnersPage;
